import React from 'react';
import { Link } from 'react-router-dom';

const ResourcesPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center">
          <h1 className="text-4xl font-extrabold text-gray-900 sm:text-5xl sm:tracking-tight lg:text-6xl">
            Resources
          </h1>
          <p className="mt-5 max-w-xl mx-auto text-xl text-gray-500">
            Tools and resources to help you make a greater impact
          </p>
        </div>

        <div className="mt-12 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {/* Webinar Card */}
          <Link 
            to="/resources/coraa-ai-webinar" 
            className="flex flex-col rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 bg-white"
          >
            <div className="flex-shrink-0">
              <div className="h-48 bg-gradient-to-r from-green-600 to-green-400 flex items-center justify-center">
                <span className="text-white text-4xl">📹</span>
              </div>
            </div>
            <div className="flex-1 p-6 flex flex-col justify-between">
              <div className="flex-1">
                <p className="text-sm font-medium text-green-600">Webinar</p>
                <h3 className="mt-2 text-xl font-semibold text-gray-900">
                  Meet CORAA: Your AI Co-Pilot for CSR & Volunteering
                </h3>
                <p className="mt-3 text-base text-gray-500">
                  Learn how CORAA can transform your CSR and volunteering programs with AI-powered automation.
                </p>
              </div>
              <div className="mt-6 flex items-center">
                <div className="text-green-600 hover:text-green-500">
                  Watch now →
                </div>
              </div>
            </div>
          </Link>

          {/* NPO Landing US Card */}
          <Link 
            to="/nonprofit" 
            className="flex flex-col rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 bg-white"
          >
            <div className="flex-shrink-0">
              <div className="h-48 bg-gradient-to-r from-[#C62828] to-[#2D7D46] flex items-center justify-center">
                <span className="text-white text-4xl">❤️💚</span>
              </div>
            </div>
            <div className="flex-1 p-6 flex flex-col justify-between">
              <div className="flex-1">
                <p className="text-sm font-medium text-[#C62828]">For Nonprofits</p>
                <h3 className="mt-2 text-xl font-semibold text-gray-900">
                  AI Growth Engine for Nonprofits
                </h3>
                <p className="mt-3 text-base text-gray-500">
                  Discover how CauseConnect can help your nonprofit grow and increase your impact with AI-powered tools.
                </p>
              </div>
              <div className="mt-6 flex items-center">
                <div className="text-[#C62828] hover:text-[#2D7D46] transition-colors">
                  Explore Now →
                </div>
              </div>
            </div>
          </Link>

        </div>
      </div>
    </div>
  );
};

export default ResourcesPage;
